import { __awaiter } from 'tslib';
import * as Long from 'long';
import { im_proto } from '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import { BaseApiManager } from '../../core/plugin/BaseApiManager.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../core/network/NetworkItem.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class RtcApiManager extends BaseApiManager {
    CreateVoip(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                create_voip_body: {
                    ref_channel_id: params.refChannelId,
                    voip_mode: params.voipMode,
                    idempotent_id: params.idempotentId,
                    v_type: params.type,
                    con_short_id: params.shortId ? Long.fromValue(params.shortId) : undefined,
                    srv_msg_id: params.serverMessageId ? Long.fromValue(params.serverMessageId) : undefined
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.CREATE_VOIP)).create_voip_body;
        });
    }
    CallVoip(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                call_voip_body: {
                    callee_ids: params.calleeIds.map(c => Long.fromValue(c)),
                    channel_id: params.channelId,
                    v_type: params.type,
                    ext: params.ext,
                    ref_channel_users: params.refChannelUsers.map(c => Long.fromValue(c))
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.CALL_VOIP)).call_voip_body;
        });
    }
    UpdateVoip(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                update_voip_body: {
                    channel_id: params.channelId,
                    status: params.status,
                    v_type: params.type
                }
            });
            return (yield this.send(reqBody, im_proto.IMCMD.UPDATE_VOIP)).update_voip_body;
        });
    }
    ChannelHeartbeat(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const reqBody = im_proto.RequestBody.create({
                channel_heartbeat_body: {
                    channel_id: params.channelId
                }
            });
            return this.send(reqBody, im_proto.IMCMD.HEARTBEAT_CHANNEL, {
                maxRetryTimes: 1
            });
        });
    }
}

export { RtcApiManager };
//# sourceMappingURL=RtcApiManager.js.map
